import { Component, inject, signal } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AutoSaveOfferResult } from '../auto-save.service';

/**
 * Offer to turn auto-save on (DEV-10936).
 *
 * Shown on top of an "Update Order" that already went through, so none of its
 * buttons gate the save. Dismissing it — Esc or the X — means "keep saving
 * manually" for this session, never "don't show this again".
 */
@Component({
  selector: 'app-auto-save-offer',
  imports: [MatCheckboxModule],
  templateUrl: './auto-save-offer.component.html',
  styleUrl: './auto-save-offer.component.scss'
})
export class AutoSaveOfferComponent {

  #activeModal = inject(NgbActiveModal);

  dontShowAgain = signal(false);

  handleCheckboxChange(checked: boolean) {
    this.dontShowAgain.set(checked);
  }

  close(enableAutoSave: boolean) {
    const result: AutoSaveOfferResult = { enableAutoSave, dontShowAgain: this.dontShowAgain() };
    this.#activeModal.close(result);
  }
}
